type PropsType = {
  children: React.ReactNode;
};

export const TopContentBottomControls = (props: PropsType) => {
  return <div className="top-content-bottom-controls">{props.children}</div>;
};
